var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailureicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.001,
    height: 73.132,
    viewBox: "0 0 78.001 73.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#862633;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.941 -30.211)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M70.6,73.132H7.4A7.381,7.381,0,0,1,.916,62.188L32.509,3.874a7.376,7.376,0,0,1,12.983,0L77.083,62.188h0a7.381,7.381,0,0,1-6.468,10.944Zm0-5.093a2.3,2.3,0,0,0,2-1.145h0a2.293,2.293,0,0,0,.076-2.309L41.055,6.238a2.341,2.341,0,0,0-4.11,0L5.326,64.586A2.341,2.341,0,0,0,7.4,68.039ZM36.474,56.75V53.383a2.526,2.526,0,0,1,5.052,0V56.75a2.526,2.526,0,0,1-5.052,0Zm0-11.786V24.76a2.526,2.526,0,1,1,5.052,0v20.2a2.526,2.526,0,0,1-5.052,0Z",
    transform: "translate(12.941 30.211)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureicon);
export default __webpack_public_path__ + "static/media/failure.icon.b07924a8ef64ded33746bda34501c82e.svg";
export { ForwardRef as ReactComponent };